import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AndroidBuildComponent } from './build/android-build/android-build.component'
import { ConnectivityComponent } from './connectivity/connectivity.component'
import { Authguard } from './guards/authguard.service'
import { Tourguard } from './guards/tourguard.service'
import { LoginComponent } from './login/login.component'
import { ForceLogoutComponent } from './login/force-logout.component'
import { PushNotificationsComponent } from './addons/push-notifications/push-notifications.component'
import { ContentSettingsComponent } from './settings/content-settings/content-settings.component'
import { AppBasicsComponent } from './settings/app-basics/app-basics.component'
import { ViewBuilderComponent } from './view-builder/view-builder.component'
import { IosBuildComponent } from './build/ios-build/ios-build.component'
import { ChangelogComponent } from './pages/changelog/changelog.component'
import { ViewsComponent } from './views/views.component'
import { AdminComponent } from './admin/admin/admin.component'
import { ProjectsComponent } from './pages/projects/projects.component'
import { AppPreviewComponent } from './pages/app-preview/app-preview.component'
import { CloudSubsComponent } from './admin/admin-analytics/cloud/cloud-subs/cloud-subs.component'
import { CloudComponent } from './admin/admin-analytics/cloud/cloud.component'
import { SelfComponent } from './admin/admin-analytics/self/self.component'
import { AdminauthGuard } from './guards/adminauth.guard'
import { LogsComponent } from './admin/admin-analytics/logs/logs.component'
import { AnalyticsPageStatsComponent } from './pages/analytics/analytics-page-stats/analytics-page-stats.component'
import { ExpiredComponent } from './pages/expired/expired.component'
import { AnalyticsOrdersComponent } from './pages/analytics/analytics-orders/analytics-orders.component'
import { PosthogAnalyticsComponent } from './pages/analytics/posthog/components/posthog-analytics/posthog-analytics.component'
import { WebviewGuard } from './guards/webview.guard'
import { SignupComponent } from './signup/signup.component'
import { SiteTypeComponent } from './pages/site-type/site-type.component'
import { NavigationEnd, Router } from '@angular/router'
import { MixpanelService } from './tracking/mixpanel.service'
import { LtdComponent } from './pages/ltd/ltd.component'
import { VersionsComponent } from './pages/versions/versions.component'
import { AppsUploadedComponent } from './admin/admin-analytics/apps-uploaded/apps-uploaded.component'
import { AllAppsComponent } from './admin/admin-analytics/all-apps/all-apps.component'
import { PaymentSuccessComponent } from './pages/payment-success/payment-success.component'
import { BillingComponent } from './pages/billing/billing.component'
import { BuilderService } from './builder-services/builder.service'
import { HelpComponent } from './pages/help/help.component'
import { NewProductComponent } from './e-commerce/products/new-product/new-product.component'
import { ProductsComponent } from './e-commerce/products/list/products.component'
import { CategoriesComponent } from './e-commerce/categories/list/categories.component'
import { ShippingComponent } from './e-commerce/shipping/shipping.component'
import { ShippingProvidersComponent } from './e-commerce/shipping-providers/shipping-providers.component'
import { SettingsComponent } from './e-commerce/settings/settings.component'
import { PostsListComponent } from './posts/posts-list/posts-list.component'
import { PostsCategoriesComponent } from './posts/posts-categories/posts-categories.component'
import { NewPostComponent } from './posts/new-post/new-post.component'
import { OrdersComponent } from './e-commerce/orders/orders.component'
import { SingleOrderComponent } from './e-commerce/orders/single-order/single-order.component'
import { StacksImporterComponent } from './e-commerce/stacks-importer/stacks-importer.component'
import { SubscribersListComponent } from './subscribers/subscribers-list/subscribers-list.component'
import { NewSubscriberComponent } from './subscribers/new-subscriber/new-subscriber.component'
import { MobileViewComponent } from './pages/mobile-view/mobile-view.component'
import { TemplatesNewComponent } from './templates/templates-new/templates-new.component'
import { MultilingualComponent } from './translations/multilingual/multilingual.component'
import { TxtTranslationsComponent } from './translations/txt-translations/txt-translations.component'
import { PointsComponent } from './plugins/points/components/points/points.component'
import { SocialLoginComponent } from './addons/social-login/social-login.component'
import { AdminDashboardComponent } from './admin/admin-dashboard/admin-dashboard/admin-dashboard.component'
import { PluginsServiceService } from './plugins-loader/plugins-service.service'
import { AddCouponComponent } from './e-commerce/coupons/add-coupon/add-coupon.component'
import { CouponsComponent } from './e-commerce/coupons/coupons/coupons.component'
import { AndroidApkComponent } from './build/android-apk/android-apk.component'
import { AdvancedSettingsComponent } from './settings/advanced-settings/advanced-settings.component'
import { AppUsersComponent } from './app-users/app-users.component'
import { UserDetailsComponent } from './app-users/user-details/user-details.component'
import { AllSubscribersComponent } from './subscription-flow/all-subscribers/all-subscribers.component'
import { SubscriberInfoComponent } from './subscription-flow/subscriber-info/subscriber-info.component'
import { restrictedPagesGuard } from './guards/restricted-pages.guard'
import { cancelledUserGuard } from './guards/cancelled-user.guard'
import { PointsListComponent } from 'plugins/points/components/points-list/points-list.component'
import { DiscontComponent } from './e-commerce/discount/discont/discont.component'
import { DiscountListComponent } from './e-commerce/discount/discount-list/discount-list.component'
import { DynamicSamplesComponent } from './admin/dynamic-samples/dynamic-samples.component'
import { PnAutomationComponent } from './addons/push-notifications/pn-automation/pn-automation.component'
import { CreateUserComponent } from './app-users/create-user/create-user.component'
import { userRoleGuard } from './guards/user-role.guard'
import { PaymentMethodsComponent } from './e-commerce/payment-methods/payment-methods.component'
import { MatDialog } from '@angular/material/dialog'
import { BusinessModelGuard } from './guards/business-model.guard'
import { ordersStats } from './admin/admin-analytics/orders/orders.component'
import { VendorsComponent } from './multivendor/vendors/vendors.component'
import { AddVendorComponent } from './multivendor/add-vendor/add-vendor.component'
import { DashboardComponent } from './multivendor/dashboard/dashboard.component'
import { IntegrationsComponent } from './integrations/integrations.component'
import { ZohoCallbackGuard } from './integrations/zoho/zoho-callback.guard'
import { AddonGuard } from './guards/addon.guard'
import { WebsitePageEditorComponent } from './pages/website-builder/website-page-editor/website-page-editor.component'
import { WebsiteTemplatesComponent } from './pages/website-builder/website-templates/website-templates.component'
import { WebsiteTemplatesNewComponent } from './pages/website-builder/website-templates-new/website-templates-new.component'
import { DomainComponent } from './domain/domain.component'
import { AutomaticBuildComponent } from './build/automatic-build/automatic-build.component'
import { ScrapperComponent } from './scrapper/scrapper.component'
import { CommerceOrdersComponent } from './settings/commerce-orders/commerce-orders.component'
import { GenerateAppComponent } from './build/generate-app/generate-app.component'
import { SeoSettingsComponent } from './settings/seo-settings/seo-settings.component'

const routes: Routes = [
  {
    path: '',
    component: ViewBuilderComponent,
    canActivate: [Authguard, WebviewGuard, userRoleGuard,ZohoCallbackGuard]
  },
  {
    path: 'globals',
    component: ViewBuilderComponent,
    canActivate: [Authguard, WebviewGuard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Global Elements', section: 'Globals' }
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'force-logout',
    component: ForceLogoutComponent
  },
  {
    path: 'signup',
    component: SignupComponent
  },
  {
    path: 'app-basics',
    component: AppBasicsComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'advanced-settings',
    component: AdvancedSettingsComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'seosettings',
    component: SeoSettingsComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'integrations',
    component: IntegrationsComponent,
    canActivate: [Authguard, WebviewGuard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'content-settings',
    component: ContentSettingsComponent,
    canActivate: [Authguard, Tourguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Content Settings', section: 'Settings' }
  },
  {
    path: 'commerce-orders',
    component: CommerceOrdersComponent,
    canActivate: [Authguard, Tourguard, WebviewGuard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'templates',
    component: TemplatesNewComponent,
    canActivate: [Authguard, WebviewGuard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'pushnotifications',
    component: PushNotificationsComponent,
    canActivate: [Authguard, WebviewGuard, Tourguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Push Notifications', section: 'Addons' }
  },
  {
    path: 'automation',
    component: PnAutomationComponent,
    canActivate: [Authguard, WebviewGuard, Tourguard,cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Automation', section: 'Addons' }
  },
  {
    path: 'generate-app',
    component: GenerateAppComponent,
    children: [
      { path: 'android-apk', component: AndroidApkComponent },
      { path: 'android-builder', component: AndroidBuildComponent },
      { path: 'ios-builder', component: IosBuildComponent },
      {
        path: 'auto-build',
        component: AutomaticBuildComponent,
        canActivate: [Authguard, Tourguard, cancelledUserGuard, userRoleGuard, AdminauthGuard]
      },
      { path: '', redirectTo: 'android-apk', pathMatch: 'full' },
    ],
    canActivate: [Authguard, Tourguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Generate App', section: 'Build' }
  },
  {
    path: 'e-commerce/payments',
    component: PaymentMethodsComponent,
    canActivate: [Authguard, Tourguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Payments', section: 'E-Commerce' }
  },
  {
    path: 'admin/dynamicSamples',
    component: DynamicSamplesComponent,
    canActivate: [AdminauthGuard, userRoleGuard]
  },
  {
    path: 'connectivity',
    component: ConnectivityComponent,
    canActivate: [Authguard, WebviewGuard, Tourguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'domain',
    component: DomainComponent,
    canActivate: [Authguard, cancelledUserGuard, userRoleGuard],
    data: { breadcrumb: 'Domain', section: 'Settings' }
  },
  {
    path: 'users',
    component: AppUsersComponent,
    canActivate: [Authguard, Tourguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Users', section: 'Users' }
  },
  {
    path: 'users/:userId',
    component: UserDetailsComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard],
    data: { section: 'Users', sectionPath: '/users', breadcrumb: ' View User' }
  },
  {
    path: 'changelog',
    component: ChangelogComponent
  },
  {
    path: 'views',
    component: ViewsComponent,
    canActivate: [Authguard, WebviewGuard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'website-builder',
    redirectTo: 'website-builder/edit',
    pathMatch: 'full'
  },
  {
    path: 'website-builder/edit',
    component: WebsitePageEditorComponent,
    canActivate: [Authguard, WebviewGuard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'website-templates',
    component: WebsiteTemplatesNewComponent,
    canActivate: [Authguard]
  },
  {
    path: 'website-templates/manage',
    component: WebsiteTemplatesComponent,
    canActivate: [Authguard, AdminauthGuard]
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [Authguard, AdminauthGuard]
  },
  {
    path: 'projects',
    component: ProjectsComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'app-preview',
    component: AppPreviewComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'analytics/page-stats',
    component: AnalyticsPageStatsComponent,
    canActivate: [Authguard, WebviewGuard, Tourguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'analytics/orders',
    component: AnalyticsOrdersComponent,
    canActivate: [Authguard, WebviewGuard, Tourguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'analytics/posthog',
    loadChildren: () =>
      import('./pages/analytics/posthog/posthog.module')
        .then(m => m.PosthogModule)
  },
  {
    path: 'admin/self',
    component: SelfComponent,
    canActivate: [AdminauthGuard]
  },
  {
    path: 'admin/ordersStats',
    component: ordersStats,
    canActivate: [AdminauthGuard]
  },
  {
    path: 'admin-dashboard',
    component: AdminDashboardComponent,
    canActivate: [AdminauthGuard]
  },
  {
    path: 'admin/cloud',
    component: CloudComponent,
    canActivate: [AdminauthGuard]
  },
  {
    path: 'admin/logs',
    component: LogsComponent,
    canActivate: [AdminauthGuard]
  },
  {
    path: 'admin/cloud-subs',
    component: CloudSubsComponent,
    canActivate: [AdminauthGuard]
  },
  {
    path: 'admin/apps-uploaded',
    component: AppsUploadedComponent,
    canActivate: [AdminauthGuard]
  },
  {
    path: 'admin/all-apps',
    component: AllAppsComponent,
    canActivate: [AdminauthGuard]
  },
  {
    path: 'expired',
    component: ExpiredComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'site-type',
    component: SiteTypeComponent
  },
  {
    path: 'ltd',
    component: LtdComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'versions',
    component: VersionsComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'payment_success',
    component: PaymentSuccessComponent
  },
  {
    path: 'payment_success/:token/:details/:id',
    component: PaymentSuccessComponent
  },
  {
    path: 'payment_success/:token/:package/:projectId/:priceID',
    component: PaymentSuccessComponent
  },
  {
    path: 'billing',
    component: BillingComponent,
    canActivate: [Authguard, userRoleGuard]
  },
  {
    path: 'subscribers',
    component: AllSubscribersComponent,
    canActivate: [AdminauthGuard, userRoleGuard],
    data: { breadcrumb: 'Subscribers', section: 'Users' }
  },
  {
    path: 'subscribers/info/:id',
    component: SubscriberInfoComponent,
    canActivate: [AdminauthGuard, userRoleGuard]
  },
  {
    path: 'help',
    component: HelpComponent,
    canActivate: [Authguard]
  },
  {
    path: 'products',
    component: ProductsComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Products', section: 'E-Commerce' }
  },
  {
    path: 'scrapper',
    component: ScrapperComponent,
    canActivate: [Authguard, cancelledUserGuard, userRoleGuard]
  },
  {
    path: 'social',
    component: SocialLoginComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Social Login', section: 'Addons' }
  },
  {
    path: 'multilingual',
    component: MultilingualComponent,
    canActivate: [Authguard, restrictedPagesGuard, cancelledUserGuard ,userRoleGuard,BusinessModelGuard],
    data: { breadcrumb: 'Languages', section: 'Multilingual' }
  },
  {
    path: 'txtTranslations',
    component: TxtTranslationsComponent,
    canActivate: [Authguard, restrictedPagesGuard, cancelledUserGuard ,userRoleGuard,BusinessModelGuard],
    data: { breadcrumb: 'Translations', section: 'Languages' }
  },
  {
    path: 'products/new-product',
    component: NewProductComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Add Product', section: 'E-Commerce' }
  },
  {
    path: 'products/new-product/:productId',
    component: NewProductComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Edit Product', section: 'E-Commerce' }
  },
  {
    path: 'categories/categories',
    component: CategoriesComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Categories', section: 'E-Commerce' }
  },
  {
    path: 'coupons',
    component: CouponsComponent,
    canActivate: [Authguard, restrictedPagesGuard, cancelledUserGuard ,userRoleGuard,BusinessModelGuard,BusinessModelGuard]
  },
  {
    path: 'coupons/add-coupon',
    component: AddCouponComponent,
    canActivate: [Authguard, restrictedPagesGuard, cancelledUserGuard ,userRoleGuard,BusinessModelGuard,BusinessModelGuard, AddonGuard],
    data: { addon: 'Coupon Management System', breadcrumb: 'Coupons', section: 'Addons' }
  },
  {
    path: 'discount',
    component: DiscountListComponent,
    canActivate: [Authguard, restrictedPagesGuard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'discount/add-discount',
    component: DiscontComponent,
    canActivate: [Authguard, restrictedPagesGuard, cancelledUserGuard ,userRoleGuard, AddonGuard],
    data: { addon: 'Timer and Flash Sale', breadcrumb: 'Flash Sale', section: 'Addons' }
  },
  {
    path: 'discount/add-discount/:id',
    component: DiscontComponent,
    canActivate: [Authguard, restrictedPagesGuard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'coupons/add-coupon/:id',
    component: AddCouponComponent,
    canActivate: [Authguard, userRoleGuard,BusinessModelGuard]
  },
  {
    path: 'shipping',
    component: ShippingComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Shipping', section: 'E-Commerce' }
  },
  {
    path: 'shipping-providers',
    component: ShippingProvidersComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Shipping Providers', section: 'E-Commerce' }
  },
  {
    path: 'posts/list',
    component: PostsListComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'posts/new-post',
    component: NewPostComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'posts/categories',
    component: PostsCategoriesComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'orders',
    component: OrdersComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Orders', section: 'E-Commerce' }
  },
  {
    path: 'orders/single-order/:orderId',
    component: SingleOrderComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard],
    data: { breadcrumb: 'Order Details', section: 'E-Commerce' }
  },
  {
    path: 'stacks-importer',
    component: StacksImporterComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard, Tourguard],
    data: { breadcrumb: 'Importer', section: 'E-Commerce' }
  },
  {
    path: 'admin/subList',
    component: SubscribersListComponent,
    canActivate: [Authguard]
  },
  {
    path: 'admin/newSub',
    component: NewSubscriberComponent,
    canActivate: [Authguard]
  },
  {
    path: 'admin/newSub/:subId',
    component: NewSubscriberComponent,
    canActivate: [Authguard]
  },
  {
    path: 'mobile-trials',
    component: MobileViewComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'admin/subList',
    component: SubscribersListComponent,
    canActivate: [Authguard]
  },
  {
    path: 'admin/newSub',
    component: NewSubscriberComponent,
    canActivate: [Authguard]
  },
  {
    path: 'admin/newSub/:subId',
    component: NewSubscriberComponent,
    canActivate: [Authguard]
  },
  {
    path: 'vendors',
    component: VendorsComponent,
    canActivate: [Authguard, restrictedPagesGuard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: 'vendors/new-vendor',
    component: AddVendorComponent,
    canActivate: [Authguard, restrictedPagesGuard, cancelledUserGuard ,userRoleGuard]
  },
    {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [Authguard, restrictedPagesGuard, cancelledUserGuard ,userRoleGuard]
  },
  {
    path: '*',
    component: ViewBuilderComponent,
    canActivate: [Authguard, Tourguard]
  },
  {
    path: 'create-user',
    component: CreateUserComponent,
    canActivate: [Authguard, userRoleGuard],
    data: { section: 'Users', sectionPath: '/users', breadcrumb: ' Add User' }
  },
  {
    path: 'points',
    component: PointsListComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard, restrictedPagesGuard,BusinessModelGuard]
  },
  {
    path: 'points/:id',
    component: PointsComponent,
    canActivate: [Authguard, cancelledUserGuard ,userRoleGuard, restrictedPagesGuard,BusinessModelGuard, AddonGuard],
    data: { addon: 'Points and Rewards' }
  }
]
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(
    private router: Router,
    public mixPanel: MixpanelService,
    private builderService: BuilderService,
    private pluginsService: PluginsServiceService,
    private dialog: MatDialog
  ) {
    this.router.events.subscribe((route_event) => {
      if (route_event instanceof NavigationEnd) {
        this.builderService.isListShown = true
        this.builderService.toggleSidebar = false
        this.mixPanel.init(this.builderService.selectedProject)
        this.mixPanel.track('Page View', {
          url: route_event.url
        })
      }
    })
  }
}
